import 'whatwg-fetch';
import axios from 'axios';
import loginActions from '../login/login.actions';
import {store} from '../redux/configureStore';
import {toast} from 'react-toastify';

const httpClient = axios.create();
httpClient.defaults.timeout = 30000;
const sessionTime = 28800000;
const lastRequest = 900000;

export const webApi = process.env.REACT_APP_WEB_API;

export let token = localStorage['token'];
let tokenTimestamp = localStorage['token-ts'] && parseInt(localStorage['token-ts']);
let refreshingToken = false;

const _request = (url, method, data, config = {}) => {
  const headers = {...config.headers, Authorization: config.token || token};
  if (config.noAuth || !token) delete headers.Authorization;
  if ((localStorage['sessionTime'] && Math.abs(localStorage['sessionTime'] - Date.now()) > sessionTime) ||
    (localStorage['lastRequest'] && Math.abs(localStorage['lastRequest'] - Date.now()) > lastRequest)) {
    delete headers.Authorization;
    toast.error('Su sesión ha expirado, ingrese nuevamente');
    if (store) store.dispatch(loginActions.logout());
  }
  return httpClient({url: (config.baseUrl || process.env.REACT_APP_BASE_URL) + url, method, data, headers, ...config.options}).then((res) => {
    if (res.status === 200 || res.status === 201 || res.status === 204) {
      localStorage['lastRequest'] = Date.now();
      return res.data;
    } else throw (res.data);
  }).catch((errorResponse) => {
    if (errorResponse.response.status === 401 && errorResponse.response.data && errorResponse.response.data.detail === 'Signature has expired.') {
      // window.location.reload();
    }
    throw (errorResponse.response || {status: 500});
  });
};

export const get = (url) => _request(url, 'GET');

export const post = (url, body, config = {}) => _request(url, 'POST', body, config);

export const put = (url, body, config = {}) => _request(url, 'PUT', body, config);

export const deleteRequest = (url, body, config = {}) => _request(url, 'DELETE', body, config);

export const services = {
  refreshToken: (token) => post(webApi + 'auth/refresh/', {token}),
};

export const refreshToken = () => {
  if (token && tokenTimestamp && Date.now() - tokenTimestamp > 1200000 && Date.now() - tokenTimestamp < 1800000 && !refreshingToken) {
    refreshingToken = true;
    services.refreshToken(token).then((tokenRes) => {
      if (tokenRes.token) {
        _saveToken(tokenRes.token);
      }
      refreshingToken = false;
    }).catch((err) => refreshingToken = false);
  }
};
refreshToken();

export const _saveToken = (respToken) => {
  localStorage['token'] = 'Bearer ' + respToken;
  localStorage['token-ts'] = Date.now();
  token = 'Bearer ' + respToken;
  tokenTimestamp = Date.now();
};
